import React from 'react';
import { EnergySystemAnimation } from './components/EnergySystemAnimation';
export function App() {
  return <EnergySystemAnimation data-id="element-0" />;
}